import React from "react";
import { FiFileText, FiImage, FiFilm, FiArchive, FiLayout } from 'react-icons/fi';
import { Images, Archives, Videos, Apps } from '../libs/FileTypes';

const darkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

const FileIcon = ({ ext, color }) => {
  return (
    <>
      {Images.includes(ext) && <FiImage color="#2d81b1" />}
      {Archives.includes(ext) && <FiArchive color="#AB47BC" />}
      {Videos.includes(ext) && <FiFilm color="#00BCD4" />}
      {Apps.includes(ext) && <FiLayout color="#D81B60" />}
      {!Images.includes(ext) && !Archives.includes(ext) && !Videos.includes(ext) && !Apps.includes(ext) && <FiFileText color={color[darkMode ? 1 : 0]} />}
    </>
  )
}

export default FileIcon;